import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { http } from "@/lib/api";

export const getVisitorId = () => {
  try {
    let id = localStorage.getItem("ap_vid");
    if (!id) {
      id = (crypto.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`);
      localStorage.setItem("ap_vid", id);
    }
    return id;
  } catch {
    return "";
  }
};

export const PageTracker = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const vid = getVisitorId();
    if (pathname.startsWith("/admin") || !vid || !process.env.REACT_APP_BACKEND_URL) return;
    let landing = false;
    try {
      landing = !sessionStorage.getItem("ap_sess");
      sessionStorage.setItem("ap_sess", "1");
    } catch { landing = false; }
    const utm = new URLSearchParams(window.location.search).get("utm_source") || "";
    http.post("/track", { path: pathname, visitor_id: vid, referrer: landing ? document.referrer : "", utm_source: landing ? utm : "", landing })
      .catch(() => {});
  }, [pathname]);
  return null;
};
